import * as React from "react"
import { Box, Tooltip, Typography } from "@mui/material"

export default function colorColumn() {
    return {
        name: "color",
        label: "Color",
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({ style: { textAlign: "center" } }),
            setCellProps: () => ({ style: { textAlign: "center" } }),
            customBodyRender: (value) => {
                if (!value) {
                    return <Typography color="text.disabled">—</Typography>
                }
                return (
                    <Tooltip title={value} arrow placement="top">
                        <Box
                            sx={{
                                width: 28,
                                height: 28,
                                bgcolor: value,
                                borderRadius: "50%",
                                border: "2px solid",
                                borderColor: "divider",
                                mx: "auto",
                                cursor: "pointer",
                                transition: "transform 0.2s",
                                "&:hover": {
                                    transform: "scale(1.15)"
                                }
                            }}
                        />
                    </Tooltip>
                )
            }
        }
    }
}
